export default __webpack_public_path__ + "static/media/training-illustration2.60598cf2.png";